import { Pipe,PipeTransform } from '@angular/core';

@Pipe({
  name: 'prettySize',
  standalone: true,
})
export class PrettySize implements PipeTransform {
  transform(value: any): string {
    if (value > 1 << 20) {
      const f = '' + value / (1 << 20);
      const i = f.indexOf('.');
      return (i > -1 ? f.substr(0, i + 2) : f) + 'Mb';
    }
    if (value > 1024) {
      const f = '' + value / (1 << 10);
      const i = f.indexOf('.');
      return (i > -1 ? f.substr(0, i + 2) : f) + 'Kb';
    }

    return `${value} bytes`;
  }
}
